"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const AlertDialog_1 = __importDefault(require("@/components/AlertDialog"));
function ProductsDialogAlertView({ isOpen, onClose, onDismiss, onProceed, productNameToBeDeleted, }) {
    const text = (react_1.default.createElement(react_1.default.Fragment, null,
        "Requirements associated with the product",
        " ",
        react_1.default.createElement("strong", null, productNameToBeDeleted),
        " will not be able to display it anymore."));
    return isOpen ? (react_1.default.createElement(AlertDialog_1.default, { dialogTitle: `Delete "${productNameToBeDeleted}"?`, text: text, dismissActionLabel: "Cancel", proceedWithActionLabel: "Delete anyway", isOpen: isOpen, onClose: onClose, onDismiss: onDismiss, onProceed: onProceed })) : null;
}
exports.default = ProductsDialogAlertView;
